import React from "react";
import MainTable from '../../Components/Tables/Main/MainTable'
import { requirementStates, userTypes, requirementTypes } from "../../CommonConstants";
import { useRequirements } from "../../Hooks/useRequirements";
import { useAgreements } from "../../Hooks/useAgreements";
import { useCompanies } from "../../Hooks/useCompanies";
import { useVehicles } from "../../Hooks/useVehicles";
import { useUsers } from "../../Hooks/useUsers";
import { useLeases } from "../../Hooks/useLeases";
import { useProviders } from "../../Hooks/useProviders";
import { resolveTimezoneOffsetError } from "../../CommonConstants";
// Libraries
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Message } from "@material-ui/icons";
import { useHistory } from "react-router-dom";

const Requirements = () => {
  const [requirementsData, addRequeriment, updateRequeriment, deleteRequeriment] = useRequirements();
  const [companies] = useCompanies();
  const [agreements] = useAgreements();
  let [leases] = useLeases();
  let [vehicles] = useVehicles();
  let [users] = useUsers();
  let [providers] = useProviders();

  const companyNames = companies.reduce(
    function (acc, cur) {
      acc[cur.id] = cur.name;
      return acc;
    },
    {}
  );
  const agreementIdToCompanyName = agreements.reduce(
    function (acc, cur) {
      acc[cur.id] = companyNames[cur.companyName];
      return acc;
    },
    {}
  );

  vehicles = vehicles.reduce(
    function (acc, cur) {
      const { id, brand, model, patent, year } = cur;
      acc[id] = `${brand} ${model} ${patent} ${year}`;
      return acc;
    },
    {}
  );

  leases = leases.reduce(
    function (acc, cur) {
      const { id, agreement, vehicle } = cur;
      acc[id] = `${id} - ${agreementIdToCompanyName[agreement]} - ${vehicles[vehicle]}`;
      return acc;
    },
    {}
  );

  users = users.reduce(
    function (acc, cur) {
      const { id, email, type } = cur;
      if (type === userTypes.driver.type) acc[id] = email;
      return acc;
    },
    {}
  );

  providers = providers.reduce(
    function (acc, cur) {
      const { id, name, email, address } = cur;
      acc[id] = name ? name : email ? email : address;
      return acc;
    },
    {}
  );

  const evaluateIfNewMessages = (a, b) => {
    if (a.newMessages && !b.newMessages) {
      return 1
    } else {
      return -1
    }
  }

  const orderByPriorityAndNewMessageAndActionDate = (a, b) => {
    if (a.hasPriority && b.hasPriority) {
      return evaluateIfNewMessages(a, b)
    } else if (a.hasPriority && !b.hasPriority) {
      return 1;
    } else if (b.hasPriority && !a.hasPriority) {
      return -1;
    } else {
      if (a.isNew && b.isNew) {
        return evaluateIfNewMessages(a, b)
      } else if (a.isNew && !b.isNew) {
        return 1;
      } else if (b.isNew && !a.isNew) {
        return -1;
      }
    }
    return a.creationDate > b.creationDate;
  };

  const columns = [
    { title: "Id", field: "id", hidden: true, customSort: orderByPriorityAndNewMessageAndActionDate, defaultSort: 'desc' },
    { title: "Título", field: "title" },
    { title: "Descripción", field: "description" },
    { title: "Número de arrendamiento", field: "leaseId", lookup: leases },
    { title: "Conductor", field: "driverId", editable: "never", lookup: users },
    { title: "Tipo", field: "type", lookup: requirementTypes },
    {
      title: "Estado",
      field: "state",
      editable: "onUpdate",
      lookup: requirementStates,
      initialEditValue: "pending",
    },
    {
      title: "Fecha de creación", field: "creationDate", editable: "never", type: "date", dateSetting: { locale: "es-AR" },
      render: row => row.creationDate ? <span>{resolveTimezoneOffsetError(row.creationDate, 'dd/MM/yyyy')}</span> : <span></span>,
      editComponent: props => (
          <MuiPickersUtilsProvider utils={DateFnsUtils}
              locale={props.dateTimePickerLocalization}>
              <DatePicker
                  format="dd/MM/yyyy"
                  value={props.value ? resolveTimezoneOffsetError(props.value) : null}
                  onChange={props.onChange}
                  clearable
                  InputProps={{
                      style: {
                          fontSize: 13,
                      }
                  }}
              />
          </MuiPickersUtilsProvider>
      )
    },
    {
      title: "Fecha de acción", field: "actionDate", type: "date",
      render: row => row.actionDate ? <span>{resolveTimezoneOffsetError(row.actionDate, 'dd/MM/yyyy')}</span> : <span></span>,
      editComponent: props => (
          <MuiPickersUtilsProvider utils={DateFnsUtils}
              locale={props.dateTimePickerLocalization}>
              <DatePicker
                  format="dd/MM/yyyy"
                  value={props.value ? resolveTimezoneOffsetError(props.value) : null}
                  onChange={props.onChange}
                  clearable
                  InputProps={{
                      style: {
                          fontSize: 13,
                      }
                  }}
              />
          </MuiPickersUtilsProvider>
      )
    },
    { title: "Proveedor", field: "providerId", lookup: { 0: "", ...providers } },
    { title: "¿Es prioritario?", field: "hasPriority", type: "boolean" }
  ];

  const history = useHistory();

  const actions = [
    (rowData) => ({
      icon: (props) => {
        return <Message style={{ color: props.color }} />
      },
      tooltip: "Ver mensajes",
      iconProps: { color: rowData.newMessages ? '#F00' : '#000' },
      onClick: (event, requirement) => {
        history.push(`/messages/${requirement.id}`);
      }
    }),
  ];

  return <MainTable
    title="Requerimientos"
    columns={columns}
    actions={actions}
    data={requirementsData}
    requiredFields={[
      "title",
      "description",
      "leaseId",
      "type",
      "actionDate"
    ]}
    deleteText="Se borraran los mensajes asociados"
    onRowAdd={addRequeriment}
    onRowUpdate={updateRequeriment}
    onRowDelete={deleteRequeriment}
    rowStyle={({ hasPriority, isNew }) => {
      const background = hasPriority ? "#FF9A97" : isNew ? "#a1d000" : null
      return { background }
    }}
  />
}

export default Requirements


// WEBPACK FOOTER //
// ./src/Containers/Requirements/Requirements.js